<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-3"></a>
<h1 class="toc-title"><span class="bold">Contents</span></h1>
<h2 class="toc-fm11"><a href="#/xhtml/005_Introduction"><span class="bold">Introduction</span></a></h2>
<h2 class="toc-fm11"><a href="#/xhtml/006_Acknowledgements"><span class="bold">Acknowledgements</span></a></h2>
<h2 class="toc-fm"><a href="#/xhtml/007_Chapter_1">Chapter One</a></h2>
<h2 class="toc-fm1"><a href="#/xhtml/007_Chapter_1"><span class="bold">Early Development</span></a></h2>
<h2 class="toc-fm"><span href="#/xhtml/008_Chapter_2" title="Link target outside of Sample">Chapter Two</span></h2>
<h2 class="toc-fm1"><span href="#/xhtml/008_Chapter_2" title="Link target outside of Sample"><span class="bold">Interwar Destroyers</span></span></h2>
<h2 class="toc-fm"><span href="#/xhtml/009_Chapter_3" title="Link target outside of Sample">Chapter Three</span></h2>
<h2 class="toc-fm1"><span href="#/xhtml/009_Chapter_3" title="Link target outside of Sample"><span class="bold">Second World War Destroyers</span></span></h2>
<h2 class="toc-fm"><span href="#/xhtml/010_Chapter_4" title="Link target outside of Sample">Chapter Four</span></h2>
<h2 class="toc-fm1"><span href="#/xhtml/010_Chapter_4" title="Link target outside of Sample"><span class="bold">Cold War Destroyers</span></span></h2>
<h2 class="toc-fm"><span href="#/xhtml/011_Chapter_5" title="Link target outside of Sample">Chapter Five</span></h2>
<h2 class="toc-fm1"><span href="#/xhtml/011_Chapter_5" title="Link target outside of Sample"><span class="bold">Post-Cold War Destroyers</span></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?e614ff20